import { ContentType } from '../../__generated__/graphql';
export function getContentType(url) {
    if (isYouTubeVideo(url) || isVimeoVideo(url)) {
        return ContentType.VIDEO;
    }
    else {
        return ContentType.ARTICLE;
    }
}
// TODO: Make sure all Vimeo videos are covered
// eg. should  url.startsWith('https://player.vimeo.com/') be included?
function isVimeoVideo(url) {
    return url.startsWith('https://vimeo.com/');
}
function isYouTubeVideo(url) {
    return (url.startsWith('https://m.youtube.com/watch?v=') ||
        url.startsWith('https://www.youtube.com/watch?v=') ||
        url.startsWith('http://www.youtube.com/watch?v=') ||
        url.startsWith('https://youtu.be/56EByaLd9uE') ||
        url.startsWith('http://youtu.be/56EByaLd9uE'));
}
export var ContentTypeDisplayName;
(function (ContentTypeDisplayName) {
    ContentTypeDisplayName["VIDEO"] = "Video";
    ContentTypeDisplayName["ARTICLE"] = "Article";
})(ContentTypeDisplayName || (ContentTypeDisplayName = {}));
export var typeOptions = Object.keys(ContentType).map(function (k) { return ({
    id: ContentType[k],
    name: ContentTypeDisplayName[k],
}); });
//# sourceMappingURL=content-helpers.js.map